import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';
import {
  skipDisabledPropOption,
  getMainColor,
} from '../pages/DetailsPage/common/styles';

export const SortContainer = styled(
  'div',
  skipDisabledPropOption,
)<{
  theme: ICustomTheme;
  isDisabled?: boolean;
}>(({ theme, isDisabled }) => ({
  cursor: 'pointer',
  fontSize: 18,
  color: getMainColor(theme, isDisabled),
  fontWeight: theme.typography.fontWeightBold,
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    marginLeft: theme.spacing(1),
    fontSize: 25,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 13,
    '& svg': {
      marginLeft: theme.spacing(0.5),
      fontSize: 13,
    },
  },
}));
